import {
  IconInfrastructureResort16,
  IconInfrastructureResting16,
  ISVGIconProps,
  IconInfrastructureBike16,
  IconMapBus16,
  IconMapCar16,
  IconMapHighway16,
  IconInfrastructureHospital16,
  IconFunctionalHouse16,
  IconInfrastructureKid16,
  IconMapMetroMsk16,
  IconInfrastructureParking16,
  IconMapPin16,
  IconInfrastructureRestaurant16,
  IconInfrastructureSchool16,
  IconInfrastructureStore16,
  IconMapWalk16,
  IconInfrastructurePolice16,
  IconInfrastructureScooter16,
  IconMapNoCar16,
  IconMapStreetcar16,
  IconProductCompetitor16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { TFutureRoad } from 'shared/mf-infrastructure/types/futureInfrastructure';
import { EInfrastructureType } from 'shared/mf-infrastructure/types/infrastructure';
import {
  EInsideTAInfrastructureType,
  EOutsideTAInfrastructureType,
} from 'shared/mf-infrastructure/types/transportAccessibility';

export const INFRASTRUCTURE_ICON_MAP = new Map<string, React.FunctionComponent<ISVGIconProps>>([
  ['cafe', IconInfrastructureRestaurant16],
  ['clinic', IconInfrastructureHospital16],
  ['grocery', IconInfrastructureStore16],
  ['metro', IconMapMetroMsk16],
  ['nursery', IconInfrastructureKid16],
  ['futureRoad', IconMapHighway16],
  ['school', IconInfrastructureSchool16],
  ['similar_objects', IconMapPin16],
  ['similar_newbuildings', IconFunctionalHouse16],
  ['restAreas', IconInfrastructureResting16],
  ['parks', IconInfrastructureResting16],
  ['beaches', IconInfrastructureResort16],

  [EOutsideTAInfrastructureType.busStops, IconMapBus16],
  [EOutsideTAInfrastructureType.tramStops, IconMapStreetcar16],
  [EOutsideTAInfrastructureType.metro, IconMapMetroMsk16],
  [EOutsideTAInfrastructureType.parking, IconInfrastructureParking16],
  [EOutsideTAInfrastructureType.bikeParking, IconInfrastructureBike16],
  [EOutsideTAInfrastructureType.chargingStations, IconProductCompetitor16],
  [EOutsideTAInfrastructureType.scooterParking, IconInfrastructureScooter16],

  [EInsideTAInfrastructureType.yardWithoutCars, IconMapNoCar16],
  [EInsideTAInfrastructureType.parking, IconInfrastructureParking16],
  [EInsideTAInfrastructureType.dropOffPickUpArea, IconMapCar16],
  [EInsideTAInfrastructureType.bikeParking, IconInfrastructureBike16],
  [EInsideTAInfrastructureType.chargingStations, IconProductCompetitor16],
  [EInsideTAInfrastructureType.scooterParking, IconInfrastructureScooter16],
  [EInsideTAInfrastructureType.boulevards, IconMapWalk16],
  [EInsideTAInfrastructureType.trafficSafetyElements, IconInfrastructurePolice16],
]);

export const INFRASTRUCTURE_TITLE_MAP = new Map<string, string>([
  [EInfrastructureType.SimilarObjects, 'Похожие объявления'],
  [EInfrastructureType.SimilarNewbuildings, 'Похожие ЖК'],
  [EInfrastructureType.Cafe, 'Рестораны'],
  [EInfrastructureType.Clinic, 'Медицинские учреждения'],
  [EInfrastructureType.Grocery, 'Магазины'],
  [EInfrastructureType.Metro, 'Метро'],
  [EInfrastructureType.Nursery, 'Детские сады'],
  [EInfrastructureType.School, 'Школы'],
  [EInfrastructureType.RestAreas, 'Зоны отдыха'],
]);
export const ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES: string[] = ['main', 'futureRoad' as TFutureRoad];
